/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Invalid_Case_TypeInputs */

const en_api_error_task_invalid_case_type = /** @type {(inputs: Api_Error_Task_Invalid_Case_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This activity is not available for this case type.`)
};

const pt_br2_api_error_task_invalid_case_type = /** @type {(inputs: Api_Error_Task_Invalid_Case_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta atividade não está disponível para este tipo de caso.`)
};

/**
* | output |
* | --- |
* | "This activity is not available for this case type." |
*
* @param {Api_Error_Task_Invalid_Case_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_invalid_case_type = /** @type {((inputs?: Api_Error_Task_Invalid_Case_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Invalid_Case_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_invalid_case_type(inputs)
	return pt_br2_api_error_task_invalid_case_type(inputs)
});